import base from "common/js/base"; // 导入接口域名列表
import axios from "common/js/http"; // 导入 http中创建axios实例
// import qs from 'qs'; // 根据需求是否导入qs模块

const service = {
  // 登陆
  login(params) {
    return axios.post(`${base.web_sale}/login.php`, params)/* qs.stringify( */
  },
  unreceiveOrder(params) { // 未领订单
    return axios.post(`${base.web_sale}/waiting_order.php`, params)
  },
  orderReceive(params) { // 未领订单领取操作
    return axios.post(`${base.web_sale}/take_order.php`, params)
  },
  receiveOrder(params) { // 已领订单
    return axios.post(`${base.web_sale}/received_order.php`, params)
  },
  orderDeviceSearch(params) { // 创建订单 搜索仪器 search_device.php
    return axios.post(`${base.web_sale}/search_device.php`, params)
  },
  searchCompany(params) { // 选择客户
    return axios.post(`${base.web_sale}/get_customer.php`, params)
  },
  createOrder(params) { // 创建委托单
    return axios.post(`${base.web_sale}/create_order.php`, params)
  },
  orderAddDevice(params) { // 点击添加
    return axios.post(`${base.web_sale}/get_device_price.php`, params)
  },
  getAllLab(params) { // 获取所有的实验室
    return axios.post(`${base.web_sale}/get_all_labs.php`, params)
  },
  saveOrderItem(params) { // 保存
    return axios.post(`${base.web_sale}/save_order_item.php`, params)
  },
  deleteOrderItem(params){ // delete_order_item.php 点击删除
    return axios.post(`${base.web_sale}/delete_order_item.php`, params)
  },
  queryOrderDetail(params) { // 已领订单详情
    return axios.post(`${base.web_sale}/query_order_detail.php`, params)
  },
  orderDetail(params) { // 快速订单的修改订单 order_item.php
    return axios.post(`${base.web_sale}/order_item.php`, params)
  },
  myZcOrder(params) { // 查看正式订单
    return axios.post(`${base.web_sale}/my_zc_order.php`, params)
  }, // finish_query_order.php
  finishQueryOrder(params) { // 模糊订单完成
    return axios.post(`${base.web_sale}/finish_query_order.php`, params)
  },
  getImgCode(params) {
    return axios.post(`${base.web_sale}/web_scan_qrcode.php`, params)
  },
  showDevicePrice(params) { // 报价的时候查看的信息
    return axios.post(`${base.web_sale}/show_device_price.php`, params)
  }
};
export default service;